var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPackageFlightIco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "38.693px",
    viewBox: "0 3.153 45 38.693",
    enableBackground: "new 0 3.153 45 38.693",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1.454,
    y: 37.408,
    fill: "#373E43",
    width: 42.167,
    height: 4.438
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#373E43",
    d: "M44.885,16.625c-0.477-1.775-2.297-2.83-4.072-2.353l-11.795,3.163L13.704,3.153L9.421,4.307 l9.188,15.924l-11.03,2.953l-4.361-3.43L0,20.619l4.039,7.002l1.698,2.939l3.562-0.953l11.796-3.162l9.643-2.586l11.796-3.164 C44.309,20.22,45.361,18.4,44.885,16.625z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageFlightIco);
export default __webpack_public_path__ + "static/media/package_flightIco.6e3dc58d2d19ca999626dbbd597718f9.svg";
export { ForwardRef as ReactComponent };